"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var exists_1 = __importDefault(require("@zapier/common-utils/dist/exists"));
var toString = function (thing) { return (exists_1.default(thing) ? String(thing) : ''); };
var toLowerCaseString = function (thing) { return toString(thing).toLowerCase(); };
exports.default = toLowerCaseString;
